import React, { useState } from 'react'
import './index.css'
import md5 from 'md5';
import Modal from '../../../../../components/Modal';
import Loading from '../../../../../components/Loading';

export const Checklist = ({ servicio, item, checklist }) => {


    const [modal, setModal] = useState({
        active: false,
        message: '',
        success: false
    });
    const [modalError, setModalError] = useState({
        active: false,
        message: '',
        success: false
    });
    const [loading, setLoading] = useState({
        isloading: false,
        messageLoading: "",
    });
    const [checklistDisponible, setChecklistDisponible] = useState(checklist);

    const tieneChecklist = checklist || checklistDisponible;



    const clickButtonVer = async () => {
        try {
            setLoading({
                isloading: true,
                messageLoading: "Consultando checklist...",
            })
            let response = await fetch(
                process.env.REACT_APP_URL_DTO_KMI +
                'checklist/' + process.env.REACT_APP_STAGE + '/' + item.database[0].idEntrega + '/checklist_' + md5(item.database[0].idEntrega.toString()) + '.pdf',
                { headers: { 'Authorization': 'Bearer ' + servicio.getToken() } }
            );
            setLoading({
                isloading: false,
                messageLoading: "",
            })
            if (response.status === 200) {
                response = await response.blob();

                let file = window.URL.createObjectURL(response);

                let link = document.createElement('a');
                link.href = file;
                link.target = '_blank';
                link.click();
            } else {
                setModalError({
                    active: true,
                    message: "No hay checklist asociado a esta entrega.",
                    success: false
                });
                return 0;
            }
        } catch (error) {
            setModalError({
                active: true,
                message: "Ocurrió un error al consultar el checklist.",
                success: false
            });
            return 0;
        }
    }

    const clickButtonGenerar = async () => {
        setLoading({
            isloading: true,
            messageLoading: "Generando checklist...",
        })
        try {
            let response = await fetch(
                process.env.REACT_APP_URL_DTO_KMI + 'soporte/admin',
                {
                    headers: {
                        'Authorization': 'Bearer ' + servicio.getToken(),
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        idEntrega: item.database[0].idEntrega,
                        generarChecklist: true
                    })
                }
            );

            setLoading({
                isloading: false,
                messageLoading: "",
            });
            if (response.status === 200) {
                setChecklistDisponible(true);
                setModal({
                    active: true,
                    message: "Checklist generado correctamente",
                    success: true
                });

                return 0;
            } else {
                setModalError({
                    active: true,
                    message: "Error al generar el checklist.",
                    success: false
                });
                return 0;
            }
        } catch (error) {
            setLoading({
                isloading: false,
                messageLoading: "",
            })
            setModalError({
                active: true,
                message: "Ocurrió un error al generar el checklist.",
                success: false
            });
            return 0;
        }
    }

    return (
        <div className='checklist-container'>
            <div className='checklist-text'>
                <p className={!tieneChecklist ? `checklist-title-error` : 'checklist-title'}>Checklist</p>
                {!tieneChecklist && (
                    <p className='checklist-error'>No existe un checklist</p>
                )}
            </div>
            <div className='checklist-button' onClick={tieneChecklist ? clickButtonVer : clickButtonGenerar}>
                {tieneChecklist ? <p>Ver</p> : <p>Generar</p>}
            </div>
            <Modal modalInfo={modal} setMostrarModal={setModal} />
            <Modal modalInfo={modalError} setMostrarModal={setModalError} />
            {loading.isloading && <Loading />}
        </div>
    )
}
